// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.OrderItem_orderItem__\\+DwUn {
  width: 100%;
  border-radius: 16px;
  padding: 8px;
  background: #fff;
  box-shadow: 0px 5px 9px 0px rgba(0, 0, 0, 0.0509803922);
  position: relative;
  margin-bottom: 12px;
  text-align: left;
  cursor: pointer;
  transition: var(--transition);
  transition-property: box-shadow;
}
@media (hover: hover) {
  .OrderItem_orderItem__\\+DwUn:hover {
    box-shadow: 0px 5px 9px 0px rgba(0, 0, 0, 0.2);
  }
}
@media (min-width: 640px) {
  .OrderItem_orderItem__\\+DwUn {
    padding: 16px;
  }
}
.OrderItem_orderItem__\\+DwUn:last-child {
  margin-bottom: 0;
}

.OrderItem_inner__grgou {
  display: flex;
  flex-direction: column;
  justify-content: center;
}
.OrderItem_inner__grgou .OrderItem_content-container__ahDho {
  display: flex;
  align-items: center;
  padding-right: 32px;
}
@media (min-width: 1200px) {
  .OrderItem_inner__grgou {
    flex-wrap: nowrap;
  }
}

.OrderItem_imgWrap__YdFWi {
  width: 40px;
  height: 40px;
  flex-shrink: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 50%;
  margin-right: 8px;
}
@media (min-width: 640px) {
  .OrderItem_imgWrap__YdFWi {
    width: 60px;
    height: 60px;
    margin-right: 12px;
  }
}
.OrderItem_imgWrap--empty__oPSeE {
  color: var(--accent-text-color);
  background-color: rgba(var(--accent-color-rgb), 0.3);
}
.OrderItem_imgWrap__YdFWi img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: inherit;
  overflow: hidden;
}

.OrderItem_time__6Wyt4 {
  position: absolute;
  bottom: 15px;
  right: 8px;
  font-size: var(--fz-sm);
  line-height: var(--lh-sm);
  color: #54575C;
}
@media (min-width: 1200px) {
  .OrderItem_time__6Wyt4 {
    position: absolute;
    right: 16px;
    top: auto;
    color: #7A808B;
    font-weight: normal;
    flex-shrink: 0;
    padding-bottom: 2px;
    margin-left: auto;
  }
}
.OrderItem_time__6Wyt4.OrderItem_time-for-history__Wjfeu {
  top: 15px;
}
@media (min-width: 1200px) {
  .OrderItem_time__6Wyt4.OrderItem_time-for-history__Wjfeu {
    bottom: 16px;
    top: auto;
  }
}

.OrderItem_message__2dAsi {
  position: absolute;
  top: -6px;
  right: -6px;
  color: var(--white);
  line-height: 100%;
  background-color: #FF3C3C;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  border: 2px solid #FAFAFA;
  font-weight: 600;
  width: 24px;
  height: 24px;
  font-size: 11px;
  padding: 0;
  z-index: 1;
}

.OrderItem_info__2jMtj {
  display: flex;
  flex-direction: column;
  justify-content: center;
  height: 100%;
  overflow: hidden;
}
@media (min-width: 1200px) {
  .OrderItem_info__2jMtj {
    align-items: flex-start;
    padding: 0 20px 0 0;
  }
}

.OrderItem_name__1v7bp {
  font-size: 16px;
  font-weight: 500;
  line-height: 114%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  max-width: 100%;
  padding-right: 12px;
}
@media (min-width: 1200px) {
  .OrderItem_name__1v7bp {
    padding-right: 0;
  }
}
.OrderItem_name__1v7bp span {
  font-weight: 400;
}

.OrderItem_description__019YS {
  margin-top: 1px;
  line-height: 114%;
  font-size: 12px;
  color: #54575C;
}
@media (min-width: 1200px) {
  .OrderItem_description__019YS {
    font-size: 12px;
    line-height: 14px;
    color: #7A808B;
  }
}

.OrderItem_canceled__Td-8R {
  margin-top: 6px;
  color: #FA8B81;
  font-size: 12px;
  font-weight: 500;
}

.OrderItem_ratingBtn__tV8uH {
  margin-top: 8px;
  width: 100%;
  display: flex;
  padding: 16px;
  justify-content: center;
  align-items: center;
  color: var(--accent-text-color);
  border-radius: 12px;
  background: var(--accent-color);
  transition: var(--transition);
  transition-property: opacity;
  font-size: var(--fz-sm);
  line-height: var(--lh-xs);
}
@media (hover: hover) {
  .OrderItem_ratingBtn__tV8uH:hover {
    opacity: 0.7;
  }
}
@media (min-width: 1200px) {
  .OrderItem_ratingBtn__tV8uH {
    background: none;
    font-size: var(--fz-sm);
    line-height: var(--lh-sm);
    font-weight: 600;
    color: var(--accent-color);
    width: auto;
    padding: 0;
    margin-top: 4px;
  }
}
.OrderItem_ratingBtn__iconWrap__NoPAB {
  display: none;
  width: 12px;
  height: 12px;
  justify-content: center;
  align-items: center;
  margin-left: 2px;
}
@media (min-width: 1200px) {
  .OrderItem_ratingBtn__iconWrap__NoPAB {
    display: flex;
  }
}

.OrderItem_orderItem__\\+DwUn .OrderItem_coordination-status-label__dM5dH {
  margin-top: 6px;
  margin-left: 0;
}`, "",{"version":3,"sources":["webpack://./src/components/OrderItem/OrderItem.module.scss"],"names":[],"mappings":"AACA;EACE,WAAA;EACA,mBAAA;EACA,YAAA;EACA,gBAAA;EACA,uDAAA;EACA,kBAAA;EACA,mBAAA;EACA,gBAAA;EACA,eAAA;EACA,6BAAA;EACA,+BAAA;AAAF;AAEE;EACE;IACE,8CAAA;EAAJ;AACF;AAGE;EAnBF;IAoBI,aAAA;EAAF;AACF;AAEE;EACE,gBAAA;AAAJ;;AAIA;EACE,aAAA;EACA,sBAAA;EACA,uBAAA;AADF;AAGE;EACE,aAAA;EACA,mBAAA;EACA,mBAAA;AADJ;AAIE;EAXF;IAYI,iBAAA;EADF;AACF;;AAIA;EACE,WAAA;EACA,YAAA;EACA,cAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,kBAAA;EACA,iBAAA;AADF;AAGE;EAVF;IAWI,WAAA;IACA,YAAA;IACA,kBAAA;EAAF;AACF;AAEE;EACE,+BAAA;EACA,oDAAA;AAAJ;AAGE;EACE,WAAA;EACA,YAAA;EACA,iBAAA;EACA,sBAAA;EACA,gBAAA;AADJ;;AAMA;EACE,kBAAA;EACA,YAAA;EACA,UAAA;EACA,uBAAA;EACA,yBAAA;EACA,cAAA;AAHF;AAKE;EARF;IASI,kBAAA;IACA,WAAA;IACA,SAAA;IACA,cAAA;IACA,mBAAA;IACA,cAAA;IACA,mBAAA;IACA,iBAAA;EAFF;AACF;AAIE;EACE,SAAA;AAFJ;AAII;EAHF;IAII,YAAA;IACA,SAAA;EADJ;AACF;;AAOA;EACE,kBAAA;EACA,SAAA;EACA,WAAA;EACA,mBAAA;EACA,iBAAA;EACA,yBAAA;EACA,kBAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,yBAAA;EACA,gBAAA;EACA,WAAA;EACA,YAAA;EACA,eAAA;EACA,UAAA;EACA,UAAA;AAJF;;AAOA;EACE,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,YAAA;EACA,gBAAA;AAJF;AAME;EAPF;IAQI,uBAAA;IACA,mBAAA;EAHF;AACF;;AAMA;EACE,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,gBAAA;EACA,uBAAA;EACA,mBAAA;EACA,eAAA;EACA,mBAAA;AAHF;AAKE;EAVF;IAWI,gBAAA;EAFF;AACF;AAIE;EACE,gBAAA;AAFJ;;AAMA;EACE,eAAA;EACA,iBAAA;EACA,eAAA;EACA,cAAA;AAHF;AAKE;EANF;IAOI,eAAA;IACA,iBAAA;IACA,cAAA;EAFF;AACF;;AAKA;EACE,eAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;AAFF;;AAKA;EACE,eAAA;EACA,WAAA;EACA,aAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,+BAAA;EACA,mBAAA;EACA,+BAAA;EACA,6BAAA;EACA,4BAAA;EACA,uBAAA;EACA,yBAAA;AAFF;AAIE;EACE;IACE,YAAA;EAFJ;AACF;AAKE;EArBF;IAsBI,gBAAA;IACA,uBAAA;IACA,yBAAA;IACA,gBAAA;IACA,0BAAA;IACA,WAAA;IACA,UAAA;IACA,eAAA;EAFF;AACF;AAIE;EACE,aAAA;EACA,WAAA;EACA,YAAA;EACA,uBAAA;EACA,mBAAA;EACA,gBAAA;AAFJ;AAII;EARF;IASI,aAAA;EADJ;AACF;;AAKA;EACE,eAAA;EACA,cAAA;AAFF","sourcesContent":["//@import \"../OrdersLine/OrdersLine.module.scss\";\n.orderItem {\n  width: 100%;\n  border-radius: 16px;\n  padding: 8px;\n  background: #fff;\n  box-shadow: 0px 5px 9px 0px #0000000D;\n  position: relative;\n  margin-bottom: 12px;\n  text-align: left;\n  cursor: pointer;\n  transition: var(--transition);\n  transition-property: box-shadow;\n\n  @media (hover: hover) {\n    &:hover {\n      box-shadow: 0px 5px 9px 0px rgba(0, 0, 0, 0.2);\n    }\n  }\n\n  @media (min-width: 640px) {\n    padding: 16px;\n  }\n\n  &:last-child {\n    margin-bottom: 0;\n  }\n}\n\n.inner {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n\n  .content-container {\n    display: flex;\n    align-items: center;\n    padding-right: 32px;\n  }\n\n  @media (min-width: 1200px) {\n    flex-wrap: nowrap;\n  }\n}\n\n.imgWrap {\n  width: 40px;\n  height: 40px;\n  flex-shrink: 0;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  border-radius: 50%;\n  margin-right: 8px;\n\n  @media (min-width: 640px) {\n    width: 60px;\n    height: 60px;\n    margin-right: 12px;\n  }\n\n  &--empty {\n    color: var(--accent-text-color);\n    background-color: rgba(var(--accent-color-rgb), 0.3);\n  }\n\n  img {\n    width: 100%;\n    height: 100%;\n    object-fit: cover;\n    border-radius: inherit;\n    overflow: hidden;\n  }\n}\n\n\n.time {\n  position: absolute;\n  bottom: 15px;\n  right: 8px;\n  font-size: var(--fz-sm);\n  line-height: var(--lh-sm);\n  color: #54575C;\n\n  @media (min-width: 1200px) {\n    position: absolute;\n    right: 16px;\n    top: auto;\n    color: #7A808B;\n    font-weight: normal;\n    flex-shrink: 0;\n    padding-bottom: 2px;\n    margin-left: auto;\n  }\n\n  &.time-for-history {\n    top: 15px;\n\n    @media (min-width: 1200px) {\n      bottom: 16px;\n      top: auto;\n    }\n  }\n}\n\n\n\n.message {\n  position: absolute;\n  top: -6px;\n  right: -6px;\n  color: var(--white);\n  line-height: 100%;\n  background-color: #FF3C3C;\n  border-radius: 50%;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  border: 2px solid #FAFAFA;\n  font-weight: 600;\n  width: 24px;\n  height: 24px;\n  font-size: 11px;\n  padding: 0;\n  z-index: 1;\n}\n\n.info {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  height: 100%;\n  overflow: hidden;\n\n  @media (min-width: 1200px) {\n    align-items: flex-start;\n    padding: 0 20px 0 0;\n  }\n}\n\n.name {\n  font-size: 16px;\n  font-weight: 500;\n  line-height: 114%;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  max-width: 100%;\n  padding-right: 12px;\n\n  @media (min-width: 1200px) {\n    padding-right: 0;\n  }\n\n  span {\n    font-weight: 400;\n  }\n}\n\n.description {\n  margin-top: 1px;\n  line-height: 114%;\n  font-size: 12px;\n  color: #54575C;\n\n  @media (min-width: 1200px) {\n    font-size: 12px;\n    line-height: 14px;\n    color: #7A808B;\n  }\n}\n\n.canceled {\n  margin-top: 6px;\n  color: #FA8B81;\n  font-size: 12px;\n  font-weight: 500;\n}\n\n.ratingBtn {\n  margin-top: 8px;\n  width: 100%;\n  display: flex;\n  padding: 16px;\n  justify-content: center;\n  align-items: center;\n  color: var(--accent-text-color);\n  border-radius: 12px;\n  background: var(--accent-color);\n  transition: var(--transition);\n  transition-property: opacity;\n  font-size: var(--fz-sm);\n  line-height: var(--lh-xs);\n\n  @media (hover: hover) {\n    &:hover {\n      opacity: 0.7;\n    }\n  }\n\n  @media (min-width: 1200px) {\n    background: none;\n    font-size: var(--fz-sm);\n    line-height: var(--lh-sm);\n    font-weight: 600;\n    color: var(--accent-color);\n    width: auto;\n    padding: 0;\n    margin-top: 4px;\n  }\n\n  &__iconWrap {\n    display: none;\n    width: 12px;\n    height: 12px;\n    justify-content: center;\n    align-items: center;\n    margin-left: 2px;\n\n    @media (min-width: 1200px) {\n      display: flex;\n    }\n  }\n}\n\n.orderItem .coordination-status-label {\n  margin-top: 6px;\n  margin-left: 0;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"orderItem": `OrderItem_orderItem__+DwUn`,
	"inner": `OrderItem_inner__grgou`,
	"content-container": `OrderItem_content-container__ahDho`,
	"imgWrap": `OrderItem_imgWrap__YdFWi`,
	"imgWrap--empty": `OrderItem_imgWrap--empty__oPSeE`,
	"time": `OrderItem_time__6Wyt4`,
	"time-for-history": `OrderItem_time-for-history__Wjfeu`,
	"message": `OrderItem_message__2dAsi`,
	"info": `OrderItem_info__2jMtj`,
	"name": `OrderItem_name__1v7bp`,
	"description": `OrderItem_description__019YS`,
	"canceled": `OrderItem_canceled__Td-8R`,
	"ratingBtn": `OrderItem_ratingBtn__tV8uH`,
	"ratingBtn__iconWrap": `OrderItem_ratingBtn__iconWrap__NoPAB`,
	"coordination-status-label": `OrderItem_coordination-status-label__dM5dH`
};
export default ___CSS_LOADER_EXPORT___;
